import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Testimonial data
const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Sharma',
    designation: 'Business Owner',
    image: '/images/resource/testimonial-1.png',
    rating: 5,
    feedback: '“S9 Travels made my vacation unforgettable! The team was so attentive to every detail, and the trip planning was seamless. Highly recommend for anyone looking for a stress-free travel experience!”',
    authorImage: '/images/resource/testimonial-1.png'
  },
  {
    id: 2,
    name: 'Miss. Priya Patel',
    designation: 'Travel Enthusiast',
    image: '/images/resource/testimonial-2.png',
    rating: 5,
    feedback: '“My experience with S9 Travels was exceptional. From booking to the trip itself, everything was well organized, and the team ensured that I had the best experience possible. I will definitely book my future travels with them!”',
    authorImage: '/images/resource/testimonial-2.png'
  },
  {
    id: 3,
    name: 'Mr. Amit Kumar',
    designation: 'Engineer',
    image: '/images/resource/testimonial-3.png',
    rating: 5,
    feedback: '“S9 Travels went above and beyond in helping me plan my family holiday. The suggestions they provided for destinations were amazing, and the entire trip was smooth from start to. I am definitely recommending them to my friends!”',
    authorImage: '/images/resource/testimonial-3.png'
  },
  {
    id: 4,
    name: 'Miss. Neha Gupta',
    designation: 'Teacher',
    image: '/images/resource/testimonial-4.png',
    rating: 5,
    feedback: '“Traveling with S9 Travels was such a wonderful experience. They ensured all our needs were met, and their attention to detail made our trip extremely comfortable. Will surely choose them for our next trip!”',
    authorImage: '/images/resource/testimonial-4.png'
  },
  {
    id: 5,
    name: 'Mr. Vikas Mehra',
    designation: 'Doctor',
    image: '/images/resource/testimonial-5.png',
    rating: 5,
    feedback: '“The planning and coordination done by S9 Travels were impeccable. They handled everything professionally, making our vacation a breeze. We are extremely happy with their services!”',
    authorImage: '/images/resource/testimonial-5.png'
  },
];


const TestimonialSection = () => {
  // Slick carousel settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,  // Show 2 testimonials per slide
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,  // When the screen width is less than 1024px, show 1 slide
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,  // When the screen width is less than 768px, show 1 slide
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="testimonial-section pt_100 pb_90 container-fluid">
      <div className="pattern-layer" style={{ backgroundImage: 'url(/images/shape/shape-3.png)' }}></div>
      <div className="auto-container">
        <div className="sec-title centred mb_50">
          <span className="sub-title">Testimonials</span>
          <h2>Love from our Clients</h2>
        </div>

        {/* Slick Carousel */}
        <Slider {...settings}>
          {testimonials.map(testimonial => (
            <div className="testimonial-block-one" key={testimonial.id}>
              <div className="inner-box">
                <ul className="rating">
                  {/* Render 5 stars based on the rating */}
                  {[...Array(testimonial.rating)].map((_, index) => (
                    <li key={index}><img src="/images/icons/icon-1.png" alt="star" /></li>
                  ))}
                </ul>
                <div className="author-box">
                  <figure className="author-thumb">
                    {/* <img src={testimonial.authorImage} alt={testimonial.name} /> */}
                  </figure>
                  <h3 className='darkcolorrr'>{testimonial.name}</h3>
                  <span className="designation">{testimonial.designation}</span>
                </div>
                <p className='text-white'>{testimonial.feedback}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default TestimonialSection;
